import React, { use, useContext, useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerSeven from "../components/DashBoardLayerSeven";
import { ConfigContext } from '../context/GlobalContext'
import { Languages } from "../Utils/Languages";
import CheckIsUserDeleted from "../data/Firebase/CheckIsUserDeleted";
import { DeletedAccountModal } from "../components/DeletedAccountModal";
import { Spinner } from "react-bootstrap";
import LoaderView from "../components/LoaderView";
import { LogoutUser } from "../data/Firebase/Authentication";
import { UserDetailsModal } from "../components/UserDetailsModal";
import * as actionType from '../context/actions';
import EditUserDataInFirebase from "../data/Firebase/User/EditUserDataInFirebase";
import { CreateNewAccountMailAPI } from "../MailAPIs/CreateNewAccountMailAPI";
import { UpdateNodeIdInFirebase } from "../data/Firebase/UpdateNodeIdInFirebase";
import CheckCustomerNode from "../data/Firebase/Customers/CheckCustomerNode";
import CheckItemNode from "../data/Firebase/Items/CheckItemNode";
import { trackScreenView } from "../Utils/EventTracker";
import axios from "axios";
import { setcustomUser } from "@softnoesis/shakebug-js";
import SyncReferralMapping from "../data/Firebase/User/SyncReferralMapping";
import GetRefereeUserDataInFirebase from "../data/Firebase/User/GetReferreUserDataInFirebase";


const HomePage = () => {

  const { state, dispatch } = useContext(ConfigContext);
  const [showRollbackModal, setShowRollbackModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);

  useEffect(() => {

    // Check if the user is deleted when the component mounts
    checkUserDeleted();
    GetRefereeUserDataInFirebase(state, dispatch, state?.SET_USER?.referral_code)

    // update user node id
    // UpdateNodeIdInFirebase(dispatch, state?.SET_USER?.user_uid, state?.SET_USER?.social_id)

    // 🔹 Sync Referral Mapping (Ensures code exists and is mapped globally)
    if (state?.SET_USER?.user_uid) {
      SyncReferralMapping(state.SET_USER.user_uid, state.SET_USER, dispatch);
    }

    trackScreenView("Dashboard", "dashboard", "website", process.env.REACT_APP_VERSION)
  }, [state?.SET_USER?.user_uid]);


  // useEffect(() => {
  //   if (state?.SET_USER?.user_uid) {
  //     setcustomUser({
  //       id: state?.SET_USER?.user_uid,
  //       name: state?.SET_USER?.name,
  //       email: state?.SET_USER?.email,
  //       country: state?.SET_USER?.country
  //     });
  //   }
  // }, [state?.SET_USER?.user_uid])

  const checkUserDeleted = async () => {
    const isDeleted = await CheckIsUserDeleted(state?.SET_USER?.user_uid);
    if (isDeleted) {
      // Handle user deletion logic here, e.g., redirect to a different page or show a message
      setShowRollbackModal(true);
    } else {
      setShowRollbackModal(false);

      setTimeout(() => {
        if (state?.SET_USER?.email == "" && state?.USERDETAILSPOPUP == true)
          setShowUserModal(true)
      }, 1000)
    }
  };

  const handleUserDetailsSubmit = (data) => {
    setShowUserModal(false);
    dispatch({ type: actionType.USERDETAILSPOPUP, payload: false });
    const userData = {
      social_id: state?.SET_USER?.social_id,
      name: data?.name,
      email: data?.email,
      contact: state?.SET_USER?.contact,
      currency: state?.SET_USER?.currency || 'IND',
      user_uid: state?.SET_USER?.user_uid || '',
      platform: "website",
      razorpayId: state?.SET_USER?.razorpayId,
    }



    dispatch({
      type: actionType.SET_USER, payload: {
        user_uid: state?.SET_USER?.user_uid,
        contact: state?.SET_USER?.contact,
        currency: state?.SET_USER?.currency,
        razorpayId: state?.SET_USER?.razorpayId,
        platform: state?.SET_USER?.platform,
        social_id: state?.SET_USER?.social_id,
        email: data?.email,
        name: data?.name,
        userPhoto: state?.SET_USER?.userPhoto
      }
    });

    CreateNewAccountMailAPI(data?.email, data?.name);

    EditUserDataInFirebase(state, dispatch, state?.USERID, userData)
  };

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title={Languages[state?.LANGUAGE]?.dashboard} state={state} />

        {/* DashBoardLayerSeven */}
        <DashBoardLayerSeven />


        <DeletedAccountModal
          show={showRollbackModal}
          onHide={() => {
            setShowRollbackModal(false)
            LogoutUser(dispatch)
            window.location.href = "/login";
          }}
          userID={state?.SET_USER?.user_uid}
          onRollback={() => {
            setShowRollbackModal(false);
          }}
          setIsLoading={setIsLoading}
        />

        <UserDetailsModal
          show={showUserModal}
          onHide={() => {
            setShowUserModal(false)
            dispatch({ type: actionType.USERDETAILSPOPUP, payload: false });
          }}
          onSubmit={handleUserDetailsSubmit}
        />

        {isLoading && (
          <LoaderView />
        )}

      </MasterLayout>
    </>
  );
};

export default HomePage;
